import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CardTravelIcon(props: IconProps) {
    return <Icon {...props} iconKey={"card_travel"}/>
}
